import React, { FC } from 'react';
import { AuthPageWrapper } from '../AuthPageLayout';
import { CreateNewPasswordPage } from 'features';

/**
 * CreateNewPassword component that renders a new password creation page.
 */
export const CreateNewPassword: FC = () => {
  return (
    <AuthPageWrapper>
      <CreateNewPasswordPage />
    </AuthPageWrapper>
  );
};
